import { useState } from "react";
import { X, Sparkles, ArrowRight, Gift } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LaunchBanner = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <section className="relative py-6 sm:py-8">
      <div className="mx-4 sm:mx-8 lg:mx-auto lg:max-w-5xl relative overflow-hidden bg-brand-navy border border-white/10">
        {/* Top accent line */}
        <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-brand-orange to-transparent" />
        {/* Bottom accent line */}
        <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-brand-sky to-transparent" />

        {/* Dismiss */}
        <button
          onClick={(e) => { e.preventDefault(); setDismissed(true); }}
          className="absolute right-3 top-3 p-1.5 text-white/30 hover:text-white/70 transition-colors z-10"
          aria-label={t("common.dismiss", "Dismiss")}
        >
          <X className="h-4 w-4" />
        </button>

        <Link
          to="/quote"
          className="relative flex flex-col lg:flex-row items-center gap-4 lg:gap-8 px-6 py-6 sm:py-8 lg:py-5 sm:px-10 group text-center lg:text-left"
        >
          {/* Icon badge — hidden on desktop, shown on mobile */}
          <div className="flex lg:hidden items-center justify-center w-10 h-10 border border-brand-sky">
            <Gift className="h-5 w-5 text-brand-sky" />
          </div>

          {/* Left: Tag + headline — grows on desktop */}
          <div className="flex-1 flex flex-col items-center lg:items-start gap-2">
            <div className="flex items-center gap-2">
              <Sparkles className="h-3 w-3 text-brand-sky" />
              <span className="text-[11px] font-bold tracking-[0.2em] uppercase text-brand-sky">
                {t("banner.launchTag", "Launch Offer")}
              </span>
            </div>
            <h3 className="text-base sm:text-xl font-bold text-white leading-tight">
              {t("banner.launchHeadline", "Free Booking Fee on All Orders")}
            </h3>
            <p className="text-xs sm:text-sm text-white/50 max-w-sm">
              {t("banner.launchSubtext", "Start shipping between Europe & Africa with zero platform fees. Limited time only.")}
            </p>
          </div>

          {/* Center: Promo code pill */}
          <div className="flex items-center gap-3 border border-dashed border-brand-orange px-4 py-2 shrink-0">
            <span className="text-[10px] text-white/50 uppercase tracking-wider">
              {t("banner.launchCode", "Use code")}
            </span>
            <span className="font-mono font-bold text-base sm:text-lg tracking-widest text-brand-orange">
              LAUNCH
            </span>
          </div>

          {/* Right: CTA */}
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-brand-sky group-hover:gap-3 transition-all duration-300 shrink-0">
            {t("banner.launchCta", "Start Shipping Free")}
            <ArrowRight className="h-4 w-4" />
          </span>
        </Link>
      </div>
    </section>
  );
};

export default LaunchBanner;
